<script lang="ts">
  import { onMount } from 'svelte';

  import { ItemService, ProjectConfigService } from '../../modules';
  import type { Item } from '../../modules/item/item.interface';
  import ItemPreview from './ItemPreview.svelte';

  export let id: string;
  export let category: string;
  export let project: string;

  const categoryConfig = ProjectConfigService.getCategoryConfig(project, category);

  let item: Item;

  onMount(async () => {
    const items = await ItemService.getBatch([parseInt(id)]);

    item = items[0];
  });
</script>

<div class="pi">
  <slot />
  {#if item && !item.url.includes('bit.ly')}
    <div class="pi-inner">
      <ItemPreview {item} {categoryConfig} />
    </div>
  {/if}
</div>

<style lang="scss">
  .pi {
    position: relative;
    width: 100%;
    height: 100%;

    &:hover {
      .pi-inner {
        opacity: 1;
        visibility: visible;
      }
    }

    .pi-inner {
      background-color: white;
      background-color: #f0f0f0;
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
      visibility: hidden;
      box-shadow: 0px 10px 20px 0px #2f2d5e0f, 0px 28px 56px 0px #2f2d5e0f;
    }
  }
</style>
